import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";

import { capitalize } from "lodash";

import { StarIcon } from "@lib/icons";

import { useGameSummaryContext } from "@Clubhouse/components/GameSummary/contexts/GameSummary";
import useGameSummaryHandlers from "@Clubhouse/components/GameSummary/hooks/useGameSummaryHandlers";
import { umpireRatingOptions } from "@Clubhouse/components/GameSummary/lib/constants";
import {
    UmpireRatingProps,
    UmpireRatings,
} from "@Clubhouse/components/GameSummary/types/gamesummary";

const UmpireRating = ({
    location,
    umpire,
    ratedUmpire,
}: UmpireRatingProps): React.JSX.Element => {
    const { game, umpireRatings, methods } = useGameSummaryContext();
    const { handleStarClick, handleStarHover, handleStarLeave } =
        useGameSummaryHandlers();

    const [tempRating, setTempRating] = useState<UmpireRatings | undefined>(
        umpireRatings.find(
            r =>
                parseInt(r.umpire.id.toString()) ===
                game.umpires?.find(u => u.location === location)?.id,
        )?.ratings,
    );

    const [hoveredStars, setHoveredStars] = useState<UmpireRatings>({
        consistency: 0,
        attitude: 0,
        effort: 0,
        overall: 0,
    });

    return (
        <div className="umpireRating" data-testid="umpireRating">
            <div className="stars">
                <Table>
                    <thead>
                        <tr>
                            <th colSpan={2}>
                                {capitalize(location)} Umpire: {umpire.name}{" "}
                                rating
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {umpireRatingOptions[location].map(
                            (ratingType, idx) => {
                                const currentUmpireRatingIndividual =
                                    ratedUmpire?.ratings[ratingType] ||
                                    undefined;

                                const currentRating = hoveredStars[ratingType];

                                return (
                                    <tr key={idx}>
                                        <td>{capitalize(ratingType)}</td>
                                        <td className="starContainer">
                                            <Form.Control
                                                type="hidden"
                                                {...methods.register(
                                                    `${location}.${ratingType}`,
                                                )}
                                            />
                                            {[1, 2, 3, 4, 5].map(idx => (
                                                <StarIcon
                                                    key={idx}
                                                    className={`bg-body-secondary icon fa-xl ${
                                                        currentUmpireRatingIndividual &&
                                                        currentUmpireRatingIndividual >=
                                                            idx
                                                            ? "rated"
                                                            : ""
                                                    } ${
                                                        currentRating &&
                                                        idx <= currentRating
                                                            ? "hovered"
                                                            : ""
                                                    }

                                                    ${
                                                        currentRating &&
                                                        idx > currentRating &&
                                                        currentRating !== 0
                                                            ? "unrated"
                                                            : ""
                                                    }`}
                                                    onMouseEnter={() =>
                                                        handleStarHover(
                                                            setHoveredStars,
                                                            ratingType,
                                                            idx,
                                                        )
                                                    }
                                                    onMouseLeave={() =>
                                                        handleStarLeave(
                                                            setHoveredStars,
                                                            ratingType,
                                                            tempRating,
                                                        )
                                                    }
                                                    onClick={() =>
                                                        handleStarClick(
                                                            location,
                                                            ratingType,
                                                            idx,
                                                            setTempRating,
                                                        )
                                                    }
                                                />
                                            ))}
                                        </td>
                                    </tr>
                                );
                            },
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default UmpireRating;
